var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00024 7.3335C8.55253 7.3335 9.00024 6.88578 9.00024 6.3335C9.00024 5.78121 8.55253 5.3335 8.00024 5.3335C7.44796 5.3335 7.00024 5.78121 7.00024 6.3335C7.00024 6.88578 7.44796 7.3335 8.00024 7.3335Z",
    fill: "#0A1419"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 1.3335C6.59479 1.33343 5.24625 1.888 4.24758 2.87669C3.2489 3.86538 2.6808 5.20827 2.66675 6.6135C2.66675 10.2668 7.36675 14.3335 7.56675 14.5068C7.6875 14.6101 7.84118 14.6669 8.00008 14.6669C8.15898 14.6669 8.31266 14.6101 8.43341 14.5068C8.66675 14.3335 13.3334 10.2668 13.3334 6.6135C13.3194 5.20827 12.7513 3.86538 11.7526 2.87669C10.7539 1.888 9.40538 1.33343 8.00008 1.3335ZM8.00008 8.66683C7.53859 8.66683 7.08747 8.52998 6.70375 8.27359C6.32004 8.0172 6.02097 7.65278 5.84436 7.22642C5.66776 6.80006 5.62155 6.33091 5.71158 5.87829C5.80161 5.42566 6.02384 5.0099 6.35017 4.68358C6.67649 4.35726 7.09225 4.13503 7.54487 4.045C7.99749 3.95497 8.46665 4.00117 8.89301 4.17778C9.31937 4.35438 9.68379 4.65345 9.94018 5.03717C10.1966 5.42088 10.3334 5.87201 10.3334 6.3335C10.3334 6.95233 10.0876 7.54583 9.65 7.98341C9.21241 8.421 8.61892 8.66683 8.00008 8.66683Z",
    fill: "#0A1419"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinAlt);
export default __webpack_public_path__ + "static/media/pin_alt.cb9fbad9982e239353f84c32ec6af20b.svg";
export { ForwardRef as ReactComponent };